// JS-chunk prefetcher for React.lazy() routes.
//
// The bottom nav calls `warmChunk(path)` on hover/touchstart. That kicks off
// the dynamic `import()` for the destination page — webpack starts streaming
// the chunk *immediately*, so by the time the click resolves (~80-150 ms later
// on iOS) the bundle is already in memory and the page mounts instantly.
//
// Each loader returns the same promise reference on repeated calls — webpack
// caches resolved modules internally, but we also de-dupe here so the
// promise chain doesn't grow unbounded.
//
// Pages listed in App.js as `eager` (Dashboard, Welcome, Login, Register)
// don't need entries here; they're already in main.js.
//
// `/* webpackPrefetch: true */` is intentionally NOT used — that tells the
// browser to fetch with rel="prefetch" (low priority, idle-time only). On a
// fast tap we want regular priority so the chunk arrives ASAP.

const CHUNK_LOADERS = {
    "/battles/shadow": () => import("@/pages/TwinBattle"),
    "/battles/twin":   () => import("@/pages/TwinBattle"),
    "/crew-map":       () => import("@/pages/CrewMap"),
    "/coach":          () => import("@/pages/Coach"),
    "/settings":       () => import("@/pages/Settings"),
    "/nutrition":      () => import("@/pages/Nutrition"),
    "/social":         () => import("@/pages/Social"),
    "/focus":          () => import("@/pages/ScreenTime"),
    "/hall-of-heroes": () => import("@/pages/HallOfHeroes"),
};

const inflight = new Map();

export function warmChunk(path) {
    const loader = CHUNK_LOADERS[path];
    if (!loader) return Promise.resolve();
    if (inflight.has(path)) return inflight.get(path);
    const p = loader().catch(() => {
        // Chunk fetch can fail on flaky network; drop the cached rejection
        // so a real navigation can retry it.
        inflight.delete(path);
    });
    inflight.set(path, p);
    return p;
}

// Auto-warm every bottom-nav destination during browser idle time.
// Called once from <NativeBootstrap> after the user is logged in. The
// chunks download in the background at low priority — the main thread
// stays responsive and Dashboard interactivity isn't delayed.
//
// We stagger by 250 ms each so 5 large bundles don't saturate the
// connection at once on mobile networks.
let warmedAll = false;
export function warmAllNavChunks() {
    if (warmedAll) return;
    warmedAll = true;

    const ric = typeof window !== "undefined" && window.requestIdleCallback
        ? window.requestIdleCallback
        : (cb) => setTimeout(cb, 800);

    ric(() => {
        const paths = Object.keys(CHUNK_LOADERS);
        paths.forEach((path, i) => {
            setTimeout(() => warmChunk(path), i * 250);
        });
    }, { timeout: 3000 });
}
